import { cn } from '@/new/lib/utils';

interface DocumentTabsProps {
  tabs: Array<{ id: string; label: string }>;
  selectedId: string | null;
  onSelect: (id: string) => void;
}

export function DocumentTabs({ tabs, selectedId, onSelect }: DocumentTabsProps) {
  return (
    <div className="mx-4 flex gap-1 overflow-x-scroll text-xs [scrollbar-width:none]">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={cn(
            'rounded-t-lg border p-1 px-2.25 pt-1.5 text-xs font-medium duration-150',
            tab.id === selectedId
              ? 'z-30 border-b-white bg-white text-nowrap text-gray-600'
              : 'truncate border-b-gray-200 bg-gray-50 text-gray-500 hover:bg-white',
          )}
          onClick={() => onSelect(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
